var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.mobileView,
            expression: "!mobileView"
          }
        ],
        staticClass: "fv cc"
      },
      [
        _c(
          "div",
          {
            staticClass: "fh cc",
            staticStyle: {
              width: "100vw",
              height: "6vh",
              background: "#005A9F"
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "fh cc",
                staticStyle: { width: "700px", height: "6vh" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "fh lc",
                    staticStyle: { width: "30%" },
                    attrs: { title: "Home" }
                  },
                  [
                    _c("img", {
                      staticStyle: { height: "25px" },
                      attrs: { id: "iconHome", src: _vm.imagenProducto },
                      on: { click: _vm.btnHome }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fh rc",
                    staticStyle: { width: "70%", height: "6vh" }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "labels",
                        staticStyle: {
                          "padding-left": "25px",
                          "padding-right": "40px"
                        },
                        on: { click: _vm.btnCliente }
                      },
                      [_vm._v(_vm._s(_vm.nombreCliente))]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.itemsCarrito != 0,
                            expression: "itemsCarrito!=0"
                          }
                        ],
                        staticClass: "globe1",
                        on: { click: _vm.btnCarrito }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.itemsCarrito) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "icon",
                      attrs: { id: "iconCarrito", src: "/dist/carrito.svg" },
                      on: { click: _vm.btnCarrito }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "dropdown",
                        on: {
                          mouseover: _vm.showDropUsuario,
                          mouseleave: _vm.hideDropUsuario
                        }
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "labels",
                            staticStyle: {
                              "padding-left": "25px",
                              "padding-right": "10px"
                            }
                          },
                          [_vm._v(_vm._s(_vm.nombreUsuario))]
                        ),
                        _vm._v(" "),
                        _c("div", { attrs: { id: "avatarGlobe" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#4969B2",
                                "font-weight": "700",
                                "font-size": "18px"
                              },
                              attrs: { id: "avatarChar" }
                            },
                            [_vm._v(_vm._s(_vm.letraNombreUsuario))]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.dropUsuario,
                                expression: "dropUsuario"
                              }
                            ],
                            staticClass: "dropdown-content-b"
                          },
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: "configuracion" } } },
                              [_vm._v("Cambiar contraseña")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "separator-menu" }),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                attrs: { href: "#cerrar" },
                                on: { click: _vm.cerrarSesion }
                              },
                              [_vm._v("Cerrar sesión")]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ]
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "separator" })
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.mobileView,
            expression: "mobileView"
          }
        ],
        staticClass: "fv cc"
      },
      [
        _c(
          "div",
          {
            staticClass: "fh cc",
            staticStyle: {
              width: "100vw",
              height: "40px",
              position: "fixed",
              top: "0px",
              background: "#005A9F"
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "fh lc",
                staticStyle: { width: "25vw", height: "100%" }
              },
              [
                _c("img", {
                  staticStyle: { "margin-left": "20px" },
                  attrs: { id: "iconHome", src: _vm.iconMenu },
                  on: { click: _vm.btnMenu }
                })
              ]
            ),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "fh rc",
                staticStyle: { width: "25vw", height: "100%" }
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.itemsCarrito != 0,
                        expression: "itemsCarrito!=0"
                      }
                    ],
                    staticClass: "globe1",
                    on: { click: _vm.btnCarrito }
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.itemsCarrito) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("img", {
                  staticStyle: { "margin-right": "10px" },
                  attrs: { id: "iconHome", src: "/dist/carrito.svg" },
                  on: { click: _vm.btnCarrito }
                }),
                _vm._v(" "),
                _c("img", {
                  staticStyle: { "margin-right": "20px" },
                  attrs: { id: "iconHome", src: "/dist/icon-home.png" },
                  on: { click: _vm.btnHome }
                })
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "separator" })
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "fh cc", staticStyle: { width: "50vw", height: "100%" } },
      [_c("img", { attrs: { id: "iconHome", src: "/dist/logo_header3.png" } })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4905682b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4905682b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/header.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4905682b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/header.vue
// module chunks = 0